export const NOTFOUND = '404';
